import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const DailyLessonLockIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/daily_lesson_lock.svg" });
};
const styles = StyleSheet.create({
    container: {
        width: 60,
        height: 60,
        display: 'block',
    },
});
